import * as React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';

// ----------------------------------------------------------------------

type ProgressProps = {
  progress: number;
  valueBuffer: number;
  uploadingFile: string;
  itemsRemaining: string;
};

const LinearProgressWithLabel = (props: LinearProgressProps & { value: number }) => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <Box sx={{ width: '100%', mr: 1 }}>
      <LinearProgress variant="determinate" {...props} />
    </Box>
    <Box sx={{ minWidth: 35 }}>
      <Typography
        variant="body2"
        sx={{ color: 'text.secondary' }}
      >{`${Math.round(props.value)}%`}</Typography>
    </Box>
  </Box>
);

const Progress: React.FC<ProgressProps> = ({
  progress,
  valueBuffer,
  uploadingFile,
  itemsRemaining,
}) => (
  <Box
    sx={{
      width: '80%',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      pb: 2,
    }}
  >
    <Box>
      <img
        src="/images/uploading.gif"
        alt="Uploading files..."
        style={{
          width: '240px',
          height: '80px',
          objectFit: 'cover',
          objectPosition: 'center',
          display: 'block',
          margin: 'auto',
        }}
      />

      <LinearProgressWithLabel
        variant="buffer"
        value={progress}
        valueBuffer={progress + valueBuffer}
      />
    </Box>

    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2">Uploading:</Typography>
        <Typography variant="subtitle2" noWrap>
          {uploadingFile}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2">Items remaining:</Typography>
        <Typography variant="subtitle2">{itemsRemaining}</Typography>
      </Box>
    </Box>
  </Box>
);

export default Progress;
